import { Star } from "lucide-react";

const LABELS = { 1: "Not good", 2: "Could be better", 3: "Okay", 4: "Good", 5: "Excellent" };

export function StarPicker({ value, onChange }) {
  return (
    <div data-testid="review-star-picker">
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n} star${n > 1 ? "s" : ""}`}
            className="w-11 h-11 grid place-items-center rounded-lg transition-transform active:scale-90" data-testid={`review-star-${n}`}>
            <Star className={`w-8 h-8 transition-colors ${n <= value ? "fill-[#FFD600] text-[#FFD600]" : "text-slate-600"}`} />
          </button>
        ))}
      </div>
      <div className="text-xs text-slate-400 mt-1 font-mono uppercase tracking-widest" data-testid="review-star-label">{LABELS[value]}</div>
    </div>
  );
}
